import { Alert, Checkbox } from 'antd';
import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { FV } from './share';

function AutoCloseEnableField() {
  const { t } = useTranslate();

  return (
    <FormField<FV['autoCloseEnable']> name="autoCloseEnable">
      {({ field: { value, onChange } }) => {
        return (
          <Alert
            banner
            showIcon={false}
            type="info"
            message={
              <>
                <h4>{t('remind.重要提醒超时自动关闭时机')}</h4>
                <Checkbox checked={value} onChange={({ target: { checked } }) => onChange(checked)}>
                  {t(
                    'remind.发起重要提醒72小时后，该重要提醒未被人工点击处理，或已满足系统特定时机处理，该强提醒则会自动关闭',
                  )}
                </Checkbox>
              </>
            }
          />
        );
      }}
    </FormField>
  );
}

export default AutoCloseEnableField;
